export default {
  unlocked_plural: '{{count}} tilbud er blevet låst op',
  unlocked: '{{offer}}-tilbuddet er blevet låst op',
  removed_one: '{{offer}}-tilbuddet er blevet fjernet',
  removed_other: '{{count}} er blevet fjernet',
};
